export const EVENT_CATALOG = [
    {
        key: 'poi',
        icon: 'fa-location-dot',
        events: [{ value: 'poi_in' }, { value: 'poi_out' }]
    },
    {
        key: 'vehicle_status',
        icon: 'fa-truck',
        events: [{ value: 'vehicle_stationary' }]
    },
    {
        key: 'temperature',
        icon: 'fa-temperature-half',
        events: [{ value: 'low_temperature' }, { value: 'high_temperature' }]
    },
    {
        key: 'ignition',
        icon: 'fa-key',
        events: [
            { value: 'vehicle_ignition_on', disabled: true },
            { value: 'vehicle_ignition_off', disabled: true }
        ]
    },
    {
        key: 'doors',
        icon: 'fa-door-open',
        events: [{ value: 'door_open' }, { value: 'door_closed' }]
    },
    {
        key: 'tachograph',
        icon: 'fa-id-card',
        events: [{ value: 'driver_card_inserted', disabled: true }]
    }
]

export function buildEventCategories(translate) {
    return EVENT_CATALOG.map((category) => ({
        ...category,
        label: translate(`notification_events.categories.${category.key}`),
        events: category.events.map((event) => ({
            ...event,
            label: event.disabled
                ? `${translate(`notification_events.events.${event.value}`)} (${translate(
                      'notification_management.event_not_supported'
                  )})`
                : translate(`notification_events.events.${event.value}`)
        }))
    }))
}
